import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import React, { Suspense } from "react";
import {MANAGE_ORDERS_URL } from "../../../../_metronic/_partials/constant/route";
import ManageOrder from "./component";

export const ManageOrderPage = () => {
    return <Suspense fallback={<LayoutSplashScreen />}>
            <ContentRoute path={MANAGE_ORDERS_URL.BASE_URL} component={ManageOrder}/>
    </Suspense>
}